import axios from 'axios';
import router from "../router";

axios.defaults.withCredentials = true

const ACCESS_TOKEN_KEY = 'Access-Token'

axios.interceptors.request.use(
  config => {
    const token = sessionStorage.getItem(ACCESS_TOKEN_KEY)
    if (token) {
      config.headers = config.headers || {}
      config.headers['Authorization'] = 'Bearer ' + token
      config.headers['Access-Token'] = token
      config.headers.token = token
      config.headers.from = 'web'
    }
    return config
  },
  error => Promise.reject(error)
)

axios.interceptors.response.use(
  response => {  //成功请求到数据
    const data = response.data
    const contentType = (response.headers && response.headers['content-type']) || ''
    if (
      (typeof data === 'string' && /^\s*</.test(data)) ||
      (contentType.indexOf('text/html') !== -1 && typeof data === 'string')
    ) {
      return Promise.reject(new Error('接口返回了 HTML 而非 JSON，请确认网关已配置 sit-api 反代'))
    }
    //这里根据后端提供的数据进行对应的处理
    if (response.data.code === 401) {
      router.push({ path: "/" });
      return
    } else {
      return response;
    }
  },
  error => {  //响应错误处理
    // HTTP 401：统一网关鉴权失败，跳转登录
    if (error.response && error.response.status === 401) {
      router.push({ path: "/" });
    }
    return Promise.reject(error)
  }
);
/**
 * 发送get请求
 * @param {*} url   请求的url地址
 * @param {*} data  请求时传递的参数
 */
export const get = (url, headers) => axios.get(url,{ headers:headers})
/**
 * 发送post请求
 * @param {*} url   请求的url地址
 * @param {*} data  传递的参数
 */

export const post = (url,data,headers) => axios.post(url,data,{
  headers: headers
})
export const postes = (url,data,headers,deviceId) => axios.post(url,data,{
  headers: headers, deviceId: deviceId
})





// WEBPACK FOOTER //
// ./src/utils/request.js